import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import ProductService from 'services/product';

const service = new ProductService();

const ProductPicker = ({ value = [], onChange, mode = 'multiple', placeholder = 'Chọn sản phẩm' }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        var list = await service.list({});
        list = Array.isArray(list) ? list : [];
        setOptions(list.map((x) => ({ label: x.name, value: x.id })));
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  return (
    <Select
      mode={mode}
      value={value}
      onChange={onChange}
      options={options}
      loading={loading}
      placeholder={placeholder}
      optionFilterProp="label"
      showSearch
    />
  );
};

export default ProductPicker;
